export function isParticipantActive(participant) {
    const {
        status_flags: {cancelled, active},
    } = participant;

    return !cancelled && active;
}
